module.exports = __webpack_public_path__ + "media/images/ir/other/calendar/year-calendar-da1a7902450fe0439ed22830c20f165a.svg";